module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-55.5f5ca976.svg";